import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { translationKeysMap } from 'src/app/services/translate/translate.key-mapper';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslateModule],
  template: `
    <div class="wrapper">
      @for (text of cellvalue(); track $index) {
        <div class="wrapper__row">
          <a
            class="ui-link-button ui-link-button_dashed"
            [routerLink]="this.routerLink($index)"
            [queryParams]="{ accountNumber: text.split('/')[0].trim() }"
          >
            {{ text | translate }}
          </a>
        </div>
      }
    </div>
  `,
  styles: `
    .wrapper__row + .wrapper__row {
      margin-top: 0.5rem;
    }
  `
})
export class AccountNumbersColumnComponent {
  item = input.required<{ [key: string]: string | string[] | null }>();
  column = input.required<TableColumn>();

  protected cellvalue = computed(() => {
    const cellvalue = this.item()[this.column().field];
    if (Array.isArray(cellvalue)) {
      return cellvalue.map(value => translationKeysMap.get(value) || value);
    }
    return (cellvalue && translationKeysMap.get(cellvalue)) || cellvalue || '';
  });

  routerLink(index: number): string[] {
    return ['../../customers', this.item()?.fullCustomerNumberUrl?.[index] ?? ''];
  }
}
